import type { FilterArgument } from "../../domain/FilterArgument";
import BaseCommand from "../BaseCommand";

export default class GetCampaignComputedVariablesQuery extends BaseCommand {
    public campaignId: string;
    public pageNumber: number;
    public pageSize: number;
    public filter: Array<FilterArgument>

    constructor() {
        super()
        this.campaignId = ""
        this.pageNumber = 1;
        this.pageSize = 10;
        this.filter = []
    }

    public getEndpoint(): string {
        return "conversation/campaign/computeds"
    }
}